import React, { Component } from 'react';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import s from './style';
import { cropToImgFile } from './utils';
import { withTranslation } from 'react-i18next';

class AvatarUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      preview: props.preview
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!nextState.cropedImg !== this.state.cropedImg) return false;
  }

  UNSAFE_componentWillMount() {
    const image = new Image();
    image.addEventListener('load', () => {
      this.setState({ image });
    });

    image.src = this.props.preview;
  }

  handleSaveClick = () => {
    this.props.onSave(this.state.cropedImg || this.props.file);
  }

  onCropComplete = (crop) => {
    const cropedImg = cropToImgFile({ crop, image: this.state.image });
    this.setState({ cropedImg });
  }


  render() {
    const { t } = this.props;
    const crop = {
      aspect: 1,
      width: 300,
      height: 300
    };

    return (
      <div className={s.UploadPhotoPopup}>
        <div className={s.UploadPhotoPopupHeader}>
          {t('components.profile.avatarUploader.update')}
        </div>
        <div className={s.cropContainer}>
          <ReactCrop
            src={this.state.preview}
            onComplete={this.onCropComplete}
            crop={crop}
            maxHeight={400}
            maxWidth={300}
            keepSelection
          />
        </div>
        <div className={s.buttons}>
          <button
            className={s.saveButton}
            onClick={this.handleSaveClick}
          >
            {t('components.profile.avatarUploader.button')}
          </button>
        </div>
      </div>
    );
  }
}

export default withTranslation()(AvatarUploader);



// WEBPACK FOOTER //
// ./src/components/Profile/AvatarUploader/AvatarUploader.js